import { useEffect } from 'react';
import { Box, Container, Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Navigate } from 'react-router';

import { useAuth } from '../../providers/AuthContext';
import { usePageTitleDispatch } from '../../providers/PageTitleContext';
import { SET_PAGE_TITLE } from '../../providers/actionTypes';

const page_title = 'Login';

const Login = (): React.JSX.Element => {
  const auth = useAuth();

  const pageTitleDispatch = usePageTitleDispatch();

  useEffect(() => {
    pageTitleDispatch({ type: SET_PAGE_TITLE, payload: page_title });
  }, [pageTitleDispatch]);

  return (
    <Box sx={{ display: 'flex' }}>
      <Container sx={{ padding: '15px' }}>
        <Grid container spacing={2} justifyContent='center' alignItems='center'>
          <Grid size={12} justifyContent='center' display='flex'>
            <Typography variant='body1'>
              Click the login button to begin.
            </Typography>
          </Grid>
          <Grid size={12} display='flex' justifyContent='center'>
            <Button
              onClick={() => auth.user_manager?.signinRedirect()}
              variant='contained'
            >
              Login
            </Button>
          </Grid>
        </Grid>
      </Container>
      {auth.user && <Navigate to='/' replace />}
    </Box>
  );
};

export default Login;
